import api from "./api";
import API_BASE_URL from "./config";

// Utilities
export const getBackendOrigin = () => {
  try {
    if (API_BASE_URL) return new URL(API_BASE_URL).origin;
  } catch {
    /* ignore parse errors, fall back to window origin */
  }
  return window.location.origin;
};

// Allowed origins for callback (Django and/or FastAPI)
export const getCallbackAllowedOrigins = () => {
  const set = new Set();
  try { if (API_BASE_URL) set.add(new URL(API_BASE_URL).origin); } catch { /* ignore */ }
  const cb = import.meta.env.VITE_CTRADER_CALLBACK_ORIGIN;
  if (cb) {
    try { set.add(new URL(cb).origin); } catch { /* ignore */ }
  }
  const fa = import.meta.env.VITE_FASTAPI_BASE_URL;
  if (fa) {
    try { set.add(new URL(fa).origin); } catch { /* ignore */ }
  }
  set.add(window.location.origin);
  return Array.from(set);
};

// 1) Start onboarding: POST /api/ctrader/onboard/
export const onboardStart = async (internalAccountId) => {
  const res = await api.post("/ctrader/onboard/", { account_id: internalAccountId });
  return res?.data ?? res;
};

// 2) List accounts: GET /api/ctrader/accounts/
export const listAccounts = async (tempId) => {
  const res = await api.get("/ctrader/accounts/", { params: { temp_id: tempId, state: tempId } });
  return res?.data ?? res;
};

// 3) Complete onboarding: POST /api/ctrader/onboard/<account_id>/complete (no trailing slash)
export const onboardComplete = async (internalAccountId, payload) => {
  const res = await api.post(`/ctrader/onboard/${internalAccountId}/complete`, payload);
  return res?.data ?? res;
};

// 4) Optionally connect session (adjust if your backend path differs)
export const connectSession = async (internalAccountId) => {
  const res = await api.post("/ctrader/connect", { account_id: internalAccountId });
  return res?.data ?? res;
};
